import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgHorizontalBarChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M50.3411 63.9972C53.1687 63.9972 55.4609 61.705 55.4609 58.8775V50.5372C55.4609 47.7097 53.1687 45.4175 50.3411 45.4175H5.1167C2.28914 45.4175 -0.00305176 47.7097 -0.00305176 50.5372V58.8775C-0.00305176 61.705 2.28914 63.9972 5.1167 63.9972H50.3411Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.6767 18.5801C42.5042 18.5801 44.7964 16.2879 44.7964 13.4603V5.12007C44.7964 2.29251 42.5042 0.000320435 39.6767 0.000320435H5.11836C2.2908 0.000320435 -0.00138859 2.29251 -0.00138859 5.12007V13.4603C-0.00138859 16.2879 2.2908 18.5801 5.11836 18.5801H39.6767Z",
			fill: "#E3EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.8757 41.2886C61.7033 41.2886 63.9955 38.9964 63.9955 36.1689V27.8286C63.9955 25.0011 61.7033 22.7089 58.8757 22.7089H5.11835C2.2908 22.7089 -0.00139367 25.0011 -0.00139367 27.8286V36.1689C-0.00139367 38.9964 2.2908 41.2886 5.11836 41.2886H58.8757Z",
			fill: "#BFDBFE"
		})
	]
});
export default SvgHorizontalBarChart;
